@use './shared' as *;

:host {
    @include hostStyle();
}

::slotted(joy-indicator) {
    margin-right: var(--joy-core-spacing-2);
}